import {qspost} from '@/plugins/axios'

/*
 * 获取标签列表
 * @constructor jack
 * */
export const merchantTagsList = () => qspost('/Index/Merchant/merchantTagsList', {})

/*
 * 添加标签分类
 * @constructor jack
 * */
export const saveMerchantTagsCate = (name, id = '') => qspost('/Index/Merchant/saveMerchantTagsCate', {name, id})

/*
 * 添加标签
 * @constructor jack
 * */
export const saveMerchantTags = (name, cid, id = '') => qspost('/Index/Merchant/saveMerchantTags', {name, cid, id})

/*
 * 删除标签分类
 * @constructor jack
 * */
export const delMerchantTagsCate = (id) => qspost('/Index/Merchant/delMerchantTagsCate', {name, id})

/*
 * 删除标签
 * @constructor jack
 * */
export const delMerchantTags = (id = '') => qspost('/Index/Merchant/delMerchantTags', {id})

/*
 * 获取小程序标签需求
 * @constructor jack
 * */
export const getMerchantTagsXuQiu = (searchName, searchPhone, searchXiangMuId, searchSheQuId, searchLouId, searchMenId, searchHuId, page, pageSize) => qspost('/Index/Merchant/getMerchantTagsXuQiu', {
  searchName,
  searchPhone,
  searchXiangMuId,
  searchSheQuId,
  searchLouId,
  searchMenId,
  searchHuId,
  page,
  pageSize
})

/*
 * 删除小程序标签需求
 * @constructor jack
 * */
export const delMerchantTagsXuQiu = (id) => qspost('/Index/Merchant/delMerchantTagsXuQiu', {id})

/*
 * 商品一级分类
 * @constructor jack
 * */
export const merchantStoreProductOneCateList = () => qspost('/Index/Merchant/merchantStoreProductOneCateList', {})

/*
 * 商品分类列表
 * @constructor jack
 * */
export const merchantStoreProductCateList = (searchPid, searchState, searchName) => qspost('/Index/Merchant/merchantStoreProductCateList', {
  searchPid,
  searchState,
  searchName
})

/*
 * 商品分类详情
 * @constructor jack
 * */
export const merchantStoreProductCateDetails = (id) => qspost('/Index/Merchant/merchantStoreProductCateDetails', {id})

/*
 * 添加、编辑商品分类
 * @constructor jack
 * */
export const saveMerchantStoreProductCate = (pid, name, icon, sort, state, id = '') => qspost('/Index/Merchant/saveMerchantStoreProductCate', {
  pid,
  name,
  icon,
  sort,
  state,
  id
})

/*
 * 删除商品分类
 * @constructor jack
 * */
export const delMerchantStoreProductCate = (id) => qspost('/Index/Merchant/delMerchantStoreProductCate', {id})

/*
 * 修改商品分类状态
 * @constructor jack
 * */
export const setMerchantStoreProductCateState = (id, state) => qspost('/Index/Merchant/setMerchantStoreProductCateState', {
  id,
  state
})

/*
 * 门店列表
 * @constructor jack
 * */
export const merchantStoreList = (searchName, page, pageSize) => qspost('/Index/Merchant/merchantStoreList', {
  searchName,
  page,
  pageSize
})

/*
 * 门店详情
 * @constructor jack
 * */
export const merchantStoreDetails = (id) => qspost('/Index/Merchant/merchantStoreDetails', {id})

/*
 * 门店详情
 * @constructor jack
 * */
export const getAdminMERList = (id) => qspost('/Index/Merchant/getAdminMERList', {id})


/*
 * 添加、编辑门店
 * @constructor jack
 * */
export const saveMerchantStore = (name, phone, image, background, desc, admin_id,hx_admin_id, state, peisongfei, peisongfei_lv, open_time, close_time, address, address_code, address_details, longitude, latitude, id = '') => qspost('/Index/Merchant/saveMerchantStore', {
  name,
  phone,
  image,
  background,
  desc,
  admin_id,
  hx_admin_id,
  state,
  peisongfei,
  peisongfei_lv,
  open_time,
  close_time,
  address,
  address_code,
  address_details,
  longitude,
  latitude,
  id
})


/*
 * 删除门店
 * @constructor jack
 * */
export const delMerchantStore = (id) => qspost('/Index/Merchant/delMerchantStore', {id})

/*
 * 修改门店状态
 * @constructor jack
 * */
export const setMerchantStoreState = (id, state) => qspost('/Index/Merchant/setMerchantStoreState', {id, state})

/*
 * 商品列表
 * @constructor jack
 * */
export const merchantStoreProductList = (searchStoreId,searchCid, searchName, page, pageSize) => qspost('/Index/Merchant/merchantStoreProductList', {
  searchStoreId,
  searchCid,
  searchName,
  page,
  pageSize
})

/*
 * 商品详情
 * @constructor jack
 * */
export const merchantStoreProductDetails = (id) => qspost('/Index/Merchant/merchantStoreProductDetails', {id})

/*
 * 添加、编辑商品
 * @constructor jack
 * */
export const saveMerchantStoreProduct = (cid, store_id, name, pay_type, stock, price, recommend_tags, not_recommend_tags, images, sort, state, sales, content, id = '') => qspost('/Index/Merchant/saveMerchantStoreProduct', {
  cid,
  store_id,
  name,
  pay_type,
  stock,
  price,
  recommend_tags,
  not_recommend_tags,
  images,
  sort,
  state,
  sales,
  content,
  id
})

/*
 * 删除商品
 * @constructor jack
 * */
export const delMerchantStoreProduct = (id) => qspost('/Index/Merchant/delMerchantStoreProduct', {id})

/*
 * 修改商品状态
 * @constructor jack
 * */
export const setMerchantStoreProductState = (id, state) => qspost('/Index/Merchant/setMerchantStoreProductState', {
  id,
  state
})

/*
 * 复制商品
 * todo 复制商品
 * @constructor jack
 * */
export const copyMerchantStoreProduct = (id) => qspost('/Index/Merchant/copyMerchantStoreProduct', {id})


/*
 * 门店option 用于下拉菜单
 * @constructor jack
 * */
export const merchantStoreOption = () => qspost('/Index/Merchant/merchantStoreOption', {})


/*
 * 订单列表
 * @constructor jack
 * */
export const merchantStoreProductOrderList = (store_id, delivery_admin, state, order_num, startTime, endTime, page, pageSize) => qspost('/Index/Merchant/merchantStoreProductOrderList', {store_id, delivery_admin, state, order_num, startTime, endTime, page, pageSize})
/*
 * 订单详情
 * @constructor jack
 * */
export const merchantStoreProductOrderDetails = (id) => qspost('/Index/Merchant/merchantStoreProductOrderDetails', {id})
/*
 * 订单核销
 * @constructor jack
 * */
export const merchantStoreProductOrderOff = (ziti_code) => qspost('/Index/Merchant/merchantStoreProductOrderOff', {ziti_code})

/*
 * 订单退款审核
 * @constructor jack
 * */
export const refundOrder = (order_id,state,reason,refund_price) => qspost('/Index/Merchant/refundOrder', {order_id,state,reason,refund_price})





/*
 * 门店：获取其他物业管家/队员
 * todo 门店：获取其他物业管家/队员
 * @constructor jack
 * */

/*
 * 门店：设置其他物业管家/队员 核销权限
 * todo 门店：设置其他物业管家/队员 核销权限
 * @constructor jack
 * */


/*
 * 用户列表
 * @constructor jack
 * */
export const merchantStoreJuminList = (searchName, searchPhone, searchXiangMuId, searchSheQuId, searchLouId, searchMenId, searchHuId, page, pageSize) => qspost('/Index/Merchant/merchantStoreJuminList', {searchName, searchPhone, searchXiangMuId, searchSheQuId, searchLouId, searchMenId, searchHuId, page, pageSize})

/*
 * 商品概况
 * @constructor jack
 * */
export const productSurvey = (store_id, startTime, endTime) => qspost('/Index/Merchant/productSurvey', {store_id, startTime, endTime})

/*
 * 商品排行
 * @constructor jack
 * */
export const productRanking = (store_id, startTime, endTime) => qspost('/Index/Merchant/productRanking', {store_id, startTime, endTime})

/*
 * 交易概况
 * @constructor jack
 * */
export const transactionSurvey = (store_id, startTime, endTime) => qspost('/Index/Merchant/transactionSurvey', {store_id, startTime, endTime})

/*
 * 比例概况
 * @constructor jack
 * */
export const proportionSurvey = () => qspost('/Index/Merchant/proportionSurvey', {})
